import { styles } from './template.scss';
import { styles as textHelpersStyles } from './../../assets/text-helpers.scss';
import { styles as colorHelpersStyles } from './../../assets/color-helpers.scss';
import { ButtonColor, ButtonFill, ButtonSize, ButtonType, FontSize } from '../../ui/gzIconButton/types';
import { FontSizes, FontWeights } from '../../types/common/types';

export const templateDashboard = document.createElement('template');

templateDashboard.innerHTML = `
  <style>${textHelpersStyles}</style>
  <style>${colorHelpersStyles}</style>
  <style>${styles}</style>
  <header class='page__header'>
    <gz-title class="title" fontWeight="${FontWeights.MEDIUM}" fontSize="${FontSizes.TITLE}"></gz-title>
  </header>
  <div class="wrapper">
    <div class="dashboard-header">
      <h1 class="pdf-title display-1 hidden"></h1>
      <div class="company-title-container line-separator" hidden><h1 class="company-title display-1" hidden></h1></div>
      <div class="company-logo is-default" hidden>
        <img src="app/webcomponents/assets/images/bd_logo.svg" width="200" height="25"></div>
      <div class="dashboard-header--items">
        <gz-company-selector id="companySelectorDropdown" class="dashboard-header--item"></gz-company-selector>
        <gz-dropdown id="timeRangeDropdown" class="dashboard-header--item"></gz-dropdown>

        <gz-select id="dashboardActions" class="dashboard-header--item">
            <gz-button type="outline" color="primary" id="actionsButton">
                <span id="actionsButtonName"></span>
                <span class="icon ds-icon-textbox_decrease"></span>
            </gz-button>
        </gz-select>
      </div>
    </div>

    <div class="reporting-period-wrapper d-flex align-items-center justify-end">
     <span class="reporting-period-title"></span>
     <span class="reporting-period-interval"></span>

     <gz-icon-button
        id="dashboard-refresh"
        class="dashboard-refresh-button"
        icon="ds-icon-refresh"
        size="${ButtonSize.SIZE_24}"
        fontsize="${FontSize.ICON_SIZE_20}"
        buttontype=${ButtonType.SQUARE}"
        buttonfill=${ButtonFill.QUIET}
        buttoncolor=${ButtonColor.SECONDARY}>

       <span class="font-icon icon-refresh_2"></span>
     </gz-icon-button>
    </div>
    <div class="widgets grid-stack"></div>
    <gz-dashboard-loading-screen class="dashboard-loader"></gz-dashboard-loading-screen>
  </div>
`;
